function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2857 14.7143V5.78571C17.2857 5.31211 17.0976 4.85791 16.7627 4.52302C16.4278 4.18814 15.9736 4 15.5 4C15.0264 4 14.5722 4.18814 14.2373 4.52302C13.9024 4.85791 13.7143 5.31211 13.7143 5.78571V14.7143H4.78571C4.31211 14.7143 3.85791 14.9024 3.52302 15.2373C3.18814 15.5722 3 16.0264 3 16.5C3 16.9736 3.18814 17.4278 3.52302 17.7627C3.85791 18.0976 4.31211 18.2857 4.78571 18.2857H13.7143V27.2143C13.7143 27.6879 13.9024 28.1421 14.2373 28.477C14.5722 28.8119 15.0264 29 15.5 29C15.9736 29 16.4278 28.8119 16.7627 28.477C17.0976 28.1421 17.2857 27.6879 17.2857 27.2143V18.2857H26.2143C26.6879 18.2857 27.1421 18.0976 27.477 17.7627C27.8119 17.4278 28 16.9736 28 16.5C28 16.0264 27.8119 15.5722 27.477 15.2373C27.1421 14.9024 26.6879 14.7143 26.2143 14.7143H17.2857Z"
});

function SvgIcPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default ForwardRef;